import React from 'react';
import { Overlay } from '../../Containers/Overlay';
import classNames from 'classnames';
import { SummaryOverlay } from '../../Containers/SummaryOverlay';
import { ScrollArea } from './ScrollArea';
import { WorkshopList } from './WorkshopList';
import { Summary } from './Summary';
import { localize } from '../../Util/L10n';

const ColumnLayout = function ({ title, body, lightTitle }) {
  return (
    <React.Fragment>
      <div
        className={classNames('WorkshopsOverlay__ColumnTitle', {
          'WorkshopsOverlay__ColumnTitle--Light': lightTitle,
        })}
      >
        {title}
        <div className="WorkshopsOverlay__ColumnTitleShadow">
          <div className="WorkshopsOverlay__ColumnTitleShadowEmitter" />
        </div>
      </div>
      <div className="WorkshopsOverlay__ColumnBody">
        <ScrollArea>{body}</ScrollArea>
      </div>
    </React.Fragment>
  );
};

export const SelectionOverlay = React.memo(function SelectionOverlay({
  id,
  value,
  workshopGroups,
  workshops,
  onSelectEventClick,
  onCloseOverlayClick,
}) {
  const summaryVdom = (
    <Summary
      value={value}
      workshops={workshops}
      onCloseOverlayClick={onCloseOverlayClick}
    />
  );

  return (
    <Overlay>
      <div className="WorkshopsOverlay__Header">
        <div className="WorkshopsOverlay__Container">
          <div className="WorkshopsOverlay__HeaderHeadingAligner">
            <h3 className="WorkshopsOverlay__HeaderHeading">
              {localize('workshopRegistrationTitle')}
            </h3>
            <a
              className="WorkshopsOverlay__Close"
              href="#"
              onClick={onCloseOverlayClick}
            >
              <i className="icon-close" />
            </a>
          </div>
        </div>
      </div>
      <div className="WorkshopsOverlay__Body">
        <div className="WorkshopsOverlay__Container">
          <div className="WorkshopsOverlay__ColumnSpacer">
            <div className="WorkshopsOverlay__ColumnLeft">
              <ColumnLayout
                title={localize('chooseTheWorkshopTitle')}
                lightTitle={true}
                body={
                  <WorkshopList
                    id={id}
                    value={value}
                    workshops={workshops}
                    workshopGroups={workshopGroups}
                    onSelectEventClick={onSelectEventClick}
                  />
                }
              />
              <SummaryOverlay>
                <ScrollArea>
                  <div className="WorkshopsOverlay__SummaryOverlayTitle">
                    {localize('summaryTitle')}
                  </div>
                  {summaryVdom}
                </ScrollArea>
              </SummaryOverlay>
            </div>
            <div className="WorkshopsOverlay__ColumnRight">
              <ColumnLayout
                title={localize('summaryTitle')}
                body={summaryVdom}
              />
            </div>
          </div>
        </div>
      </div>
    </Overlay>
  );
});
